import { render, staticRenderFns } from "./Configuraciones.vue?vue&type=template&id=2d9bc878&scoped=true"
import script from "./Configuraciones.vue?vue&type=script&lang=js"
export * from "./Configuraciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9bc878",
  null
  
)

export default component.exports